// Read-only Super Admin impersonation (#790). The sessionStorage keys are shared with the dealer app.
export const IMPERSONATION_STORAGE_KEYS = {
    TAB: 'impersonationTab',
    SESSION: 'impersonationSession',
};

export const IMPERSONATION_ERROR_CODES = {
    READ_ONLY: 'IMPERSONATION_READ_ONLY',
    ENDED: 'IMPERSONATION_ENDED',
    UNAVAILABLE: 'IMPERSONATION_UNAVAILABLE',
    HANDOFF_INVALID: 'HANDOFF_INVALID',
};

// sent to the dealer app as /impersonation?ended=<reason>
export const IMPERSONATION_END_REASONS = {
    STOPPED: 'stopped',
    EXPIRED: 'expired',
    ENDED: 'ended',
};

export const IMPERSONATION_API = {
    EXCHANGE: '/impersonation/exchange',
    STOP: '/impersonation/current/stop',
};

export const IMPERSONATION_NAMESPACE = 'impersonation';
